import { Alert } from '@backstage/ui';

import { useDialogContext } from './context';

export const SubmitErrorBui = () => {
  const { error } = useDialogContext();
  if (!error) return null;
  return <Alert status="danger" icon title={error.message} />;
};

SubmitErrorBui.displayName = 'DialogCompositeBui.SubmitError';

export default SubmitErrorBui;
